import { postMessage } from './postMessage';
import type {
  GenericHandoffEventData,
  GenericHandoffWidgetOption,
  HandoffIntegrations,
} from 'api/types';

export const postHandoffMessage = ({
  additionalParameters,
  department = '',
  email = '',
  featureFlags,
  forethoughtConversationID = '',
  integration,
  isCurrentTabPrimary,
  name = '',
  question = '',
}: {
  additionalParameters?: Record<string, unknown>;
  department?: string;
  email?: string;
  featureFlags?: string[];
  forethoughtConversationID: string | null;
  integration: HandoffIntegrations;
  isCurrentTabPrimary: boolean;
  name?: string;
  question?: string;
}): void => {
  postMessage({
    additionalParameters,
    department,
    email,
    event: 'forethoughtWidgetIntegrationHandoff',
    featureFlags,
    forethoughtConversationID,
    integration,
    isCurrentTabPrimary,
    name,
    question,
  });
};

export const postGenericHandoffMessage = ({
  eventData,
  integration,
  isCurrentTabPrimary,
  widgetOption,
}: {
  eventData: GenericHandoffEventData;
  integration: HandoffIntegrations;
  isCurrentTabPrimary: boolean;
  widgetOption: GenericHandoffWidgetOption;
}): void => {
  postMessage({
    additionalParameters: { ...eventData },
    event: 'forethoughtWidgetIntegrationHandoff',
    integration,
    isCurrentTabPrimary,
    widgetOption,
  });
};
